import { Form, Spin,Input, Space,Select, message, DatePicker, Button, Tooltip, Checkbox, Card} from 'antd';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
import { pdf } from '@react-pdf/renderer';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import {useContext, useEffect, useRef, useState } from 'react';
import constants from '../../constants/constants';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import { downloadFiles, fetchFiles, trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
import AnalysisSummary from './AnalysisSummary';
import AnalysisMasterSummary from './AnalysisMasterSummary';
import AnalysisSummaryPdf from './AnalysisSummaryPdf';
import AnalysisMasterSummaryPdf from './AnalysisMasterSummaryPdf';

const { RangePicker } = DatePicker;
const { Option } = Select;
const {TextArea } = Input;
// const currentDate = new Date()
// var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
// var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

const AnalysisTest = (props) => {
	//Variable Declaration
	const [form] = Form.useForm();
  const [rangePickerValue, setRangePickerValue] = useState([]);
  const [rangePickerValueCompare, setRangePickerValueCompare] = useState([]);
  const [checked, setChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [loaderGenerateExcel, setLoaderGenerateExcel] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [analysisloader, setAnalysisLoader] = useState(false);
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const masterBuyerId = sessionStorage.getItem('isMasterBuyer');
  const isMasterBuyer =
    masterBuyerId && masterBuyerId !== 'undefined' && masterBuyerId !== 'null';
  const [analysisInsights, setAnalysisInsights] = useState(null);
  const [prompt,setPromt]=useState("");
  // const [reportData,setReportData]=useState([]);
  // const [reportDataCompare,setReportDataCompare]=useState([]);
  const [claudeModelList, setClaudeModelList] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
	// const [pageSize, setPageSize] = useState(100);
  // const [currentPageCompare, setCurrentPageCompare] = useState(1);
	// const [pageSizeCompare, setPageSizeCompare] = useState(100);
  // const [reportDataCount,setReportDataCount]=useState([]);
  // const [reportDataCompareCount,setReportDataCompareCount]=useState([]);
  const reportRef = useRef(null);
  const iframeRef = useRef(null);
  const generatedExcelFileRef = useRef(null);

	//Function runs when range picker value is changed
	const RangePickerChanged = debounce((_, dateStrings) => {
		setRangePickerValue([
			dayjs(dateStrings[0], constants.DateFormat2),
			dayjs(dateStrings[1], constants.DateFormat2),
		]);		
	}, 500);

  const RangePickerChangedCompare = debounce((_, dateStrings) => {
		setRangePickerValueCompare([
			dayjs(dateStrings[0], constants.DateFormat2),
			dayjs(dateStrings[1], constants.DateFormat2),
		]);		
	}, 500);

  useEffect(() => {
    fetchModelList();
    trackPageAccess(buyerId,window.location.href)
    return () => {
      if (iframeRef.current?._reportResizeObserver) {
        iframeRef.current._reportResizeObserver.disconnect();
        iframeRef.current._reportResizeObserver = null;
      }
    };
  }, []);


  const onCheckedChange=(e)=>{
    setChecked(e.target.checked);
  }

  	//Function to Month report data
	// const GetAnalysisReport = async (startDate, endDate, compare,currentPage, pazeSize) => {
	// 	setLoader(true);
	// 	const response = await APIUtils.apiCall('GET', WebLinks.GetAnalysisReportData + buyerId + "&fromDate=" + startDate + "&toDate=" + endDate + "&limit=" + pazeSize + "&pageNo=" + currentPage);
	// 	if (!response.isCatch && response.resultObj.statusCode === "2000") {
  //     if(compare==="t"){
  //       setReportDataCompare(response.resultObj.data);
  //       setReportDataCompareCount(response.resultObj.getCount);
  //     }else{
  //       setReportDataCount(response.resultObj.getCount);
  //       setReportData(response.resultObj.data);
  //     }
	// 		setLoader(false);
	// 	} else {
  //     if(compare==="t"){
  //       setReportDataCompare([]);
  //     }else{
  //       setReportData([]);
  //     }
	// 		setLoader(false);
	// 		message.error(response?.resultObj?.message|| constants.ERROR_MESSAGE);
	// 	}
	// }

  // const GenerateAnalysis=async(values)=>{
  //   setAnalysisLoader(true);
  //   let payload = {
  //     buyerId: buyerId,
  //     createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
	// 		fromDate:dayjs(values.rangePicker[0]).format(constants.DateFormat2),
	// 		toDate:dayjs(values.rangePicker[1]).format(constants.DateFormat2),
  //     analyseFromDate:checked?dayjs(values.rangePickerChecked[0]).format(constants.DateFormat2):null,
	// 		analyseTo:checked?dayjs(values.rangePickerChecked[1]).format(constants.DateFormat2):null,
  //     analysisPrompt:values.prompt?values.prompt:null,
  //     claudeModel:values.claudeModel?values.claudeModel:null
  //   }
  //   let method, url, body;
  //   method = "POST";
  //   url = WebLinks.GenerateAnalysisReport;
  //   const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
  //   if (!response.isCatch || response.resultObj.statusCode === "2000") {
  //     setAnalysisInsights(response.resultObj.data);
  //     message.success(response.resultObj.message);
  //     setTimeout(() => {
  //       reportRef.current?.scrollIntoView({
  //         behavior: "smooth",
  //         block: "start",
  //       });
  //     }, 100);
  //     setAnalysisLoader(false);
  //   } else {
  //     setAnalysisLoader(false);
  //     message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
  //   }
  // }

  const SaveAnalysis=async()=>{
    setAnalysisLoader(true);
    let payload = {
      buyerId: buyerId,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
			fromDate:dayjs(rangePickerValue[0]).format(constants.DateFormat2),
			toDate:dayjs(rangePickerValue[1]).format(constants.DateFormat2),
      analyseFromDate:checked?dayjs(rangePickerValueCompare[0]).format(constants.DateFormat2):null,
			analyseTo:checked?dayjs(rangePickerValueCompare[1]).format(constants.DateFormat2):null,
      AnalysisDetails:analysisInsights?analysisInsights:null,
      analysisPrompt:prompt?prompt:null
    }
    let method, url, body;
    method = "POST";
    url = WebLinks.SaveAnalysisReport;
    const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
      message.success(response.resultObj.message);
      setAnalysisLoader(false);
    } else {
      setAnalysisLoader(false);
      message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  }

  	//Function to download as excel
	const downloadFile = (/* fromDate,toDate */) => {
    // downloadFiles(WebLinks.DownloadAnalysisExcel+buyerId+"&fromDate="+fromDate+"&toDate="+toDate,"AnalysisExcel.xlsx");
    // setTimeout(() => {
      // 		setLoader(false)
      // }, 3000);
      const masterBuyerId = sessionStorage.getItem('isMasterBuyer');
      const isMasterBuyer =
        masterBuyerId && masterBuyerId !== 'undefined' && masterBuyerId !== 'null';
      
      if (!rangePickerValue || rangePickerValue.length === 0) {
        message.error("Please select the date to generate the summary.");
        return;
      }
      const fromDate = rangePickerValue[0].format(constants.DateFormat2);
      const toDate = rangePickerValue[1].format(constants.DateFormat2);
      setLoader(true)
    try {
      downloadFiles(
        (isMasterBuyer
          ? WebLinks.GenerateMasterExecutiveSummaryExcel + masterBuyerId
          : WebLinks.GenerateExecutiveSummaryExcel + buyerId) +
        "&fromDate=" + fromDate + "&toDate=" + toDate, "Executive Summary.xlsx");
    } catch (_error) {
      message.error("Failed to generate summary Excel file.");
    } finally {
      setLoader(false);
    }
	};

  // const DownloadInsights = () => {
	// 	setLoader(true)
  //   let payload={
  //     dataAnalysedText: analysisInsights
  //   }
	// 	downloadFiles(WebLinks.DownloadAnalysisInsightDoc,"AnalysisInsights.docx",JSON.stringify(payload));
  //   setTimeout(() => {
	// 			setLoader(false)
	// 	}, 3000);
	// };

  const generateSummary = async () => {
    const masterBuyerId = sessionStorage.getItem('isMasterBuyer');
    const isMasterBuyer =
      masterBuyerId && masterBuyerId !== 'undefined' && masterBuyerId !== 'null';
    if (!rangePickerValue || rangePickerValue.length === 0) {
      message.error("Please select the date to generate the summary.");
      return;
    }
    const fromDate = rangePickerValue[0].format(constants.DateFormat2);
    const toDate = rangePickerValue[1].format(constants.DateFormat2);
    setLoaderGenerateExcel(true);
    try {
      const excelBlob = await fetchFiles(
        (isMasterBuyer
          ? WebLinks.GenerateMasterExecutiveSummaryExcel + masterBuyerId
          : WebLinks.GenerateExecutiveSummaryExcel + buyerId) +
        "&fromDate=" + fromDate + "&toDate=" + toDate);
      if(excelBlob) {
        generatedExcelFileRef.current = excelBlob;
        message.success('Summary generated successfully.');
      }
    } catch (_error) {
      message.error("Failed to generate summary Excel file.");
    } finally {
      setLoaderGenerateExcel(false);
    }
  };

  const generateNewAnalysis = async (values) => {
    const masterBuyerId = sessionStorage.getItem('isMasterBuyer');
    const isMasterBuyer =
      masterBuyerId && masterBuyerId !== 'undefined' && masterBuyerId !== 'null';
    const uploadedFile = generatedExcelFileRef.current;
    if (!uploadedFile) {
      message.error("Please generate and upload the Excel summary first before generating the report.");
      return null;
    }
    const formData = new FormData();
    setAnalysisLoader(true);
    formData.append("excelFile", uploadedFile, "Executive Summary Report.xlsx");
    const promptValue = values?.prompt;
    if (promptValue) {
      formData.append("prompt", promptValue);
    }
    const selectedModel = values.claudeModel ? values.claudeModel : null;
    if (selectedModel) {
      formData.append("claudeModel", selectedModel);
    }
    try {
      const response = await fetch(
        isMasterBuyer
          ? WebLinks.GetMasterAnalysisInsights
          : WebLinks.GenerateAnalysisExcelInsights, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + Cookies.get(constants.COOKIE_TOKEN),
        },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok) {
        message.error(result?.message || constants.ERROR_MESSAGE);
        return null;
      }
      message.success(result?.message || "Analysis generated successfully.");
      setAnalysisInsights(result?.data);
      setTimeout(() => {
        reportRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
      setAnalysisLoader(false);
      return result;
    } catch (error) {
      setAnalysisLoader(false);
      message.error(constants.ERROR_MESSAGE);
      return null;
    }
  };

	//Function on change of report table
	// const onchangeReportTable = (pagination, filters, sorter) => {
	// 	if (pagination) {
	// 		if (pageSize !== pagination.pageSize) {
	// 			setCurrentPage(1);
	// 		} else {
	// 			setCurrentPage(pagination?.current);
	// 		}
	// 		setPageSize(pagination?.pageSize);
  //     GetAnalysisReport(rangePickerValue[0].format(constants.DateFormat2),rangePickerValue[1].format(constants.DateFormat2),"f",pagination?.current, pagination?.pageSize)
	// 	}
	// };

	//Function on change of report compare table
	// const onchangeReportCompareTable = (pagination, filters, sorter) => {
	// 	if (pagination) {
	// 		if (pageSizeCompare !== pagination.pageSize) {
	// 			setCurrentPageCompare(1);
	// 		} else {
	// 			setCurrentPageCompare(pagination?.current);
	// 		}
	// 		setPageSizeCompare(pagination?.pageSize);
  //     GetAnalysisReport(rangePickerValue[0].format(constants.DateFormat2),rangePickerValue[1].format(constants.DateFormat2),"t",pagination?.current, pagination?.pageSize)
	// 	}
	// };

  // const getHtmlContent = (data) => {
  //   if (!data) return "";

  //   // If API unexpectedly returns an object
  //   if (typeof data !== "string") {
  //     console.error("Expected HTML string, received:");
  //     return "";
  //   }

  //   let html = data.trim();
  //   html = html
  //     .replace(/^```(?:html)?\s*/i, "")
  //     .replace(/\s*```$/i, "")
  //     .trim();
  //   return html;
  // };
  const disabledRangeDate = (current) => {
    if (!current) return false;

    const today = dayjs().endOf("day");
    const twoMonthsAgo = dayjs().subtract(2, "month").startOf("day");
    return (
      current.isAfter(today, "day") ||
      current.isAfter(twoMonthsAgo, "day")
    );
  };

  //Model list
  const fetchModelList = async () => {
      const response = await APIUtils.apiCall("GET", WebLinks.GetClaudeModelList);
      if (!response.isCatch) {
        setClaudeModelList(response.resultObj.data)
      } else {
        message.error(response.resultObj.message);
      }
  }
  // const handleExportPdf = async () => {
  //   if (!iframeRef.current) {
  //     message.error("Generate the report first before exporting to PDF.");
  //     return;
  //   }

  //   setLoading(true);

  //   await new Promise((resolve) => {
  //     requestAnimationFrame(() => resolve());
  //   });

  //   try {
  //     await exportIframeToPdf(iframeRef.current);
  //   } catch (error) {
  //     console.error("Error generating PDF:", error);
  //     message.error(error.message || "Failed to generate PDF.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const handleIframeLoad = () => {
  //   const iframe = iframeRef.current;

  //   if (!iframe) return;

  //   const doc = iframe.contentDocument;

  //   if (!doc) return;

  //   const updateHeight = () => {
  //     const body = doc.body;
  //     const html = doc.documentElement;

  //     if (!body || !html) return;

  //     const height = Math.max(
  //       body.scrollHeight,
  //       body.offsetHeight,
  //       html.scrollHeight,
  //       html.offsetHeight
  //     );

  //     iframe.style.height = `${height}px`;
  //   };

  //   // First measurement
  //   updateHeight();

  //   // Wait for browser layout/repaint
  //   requestAnimationFrame(() => {
  //     updateHeight();

  //     requestAnimationFrame(() => {
  //       updateHeight();
  //     });
  //   });

  //   // Handle delayed resources/layout
  //   setTimeout(updateHeight, 100);
  //   setTimeout(updateHeight, 300);
  //   setTimeout(updateHeight, 600);
  //   setTimeout(updateHeight, 1000);

  //   // Handle images that haven't finished loading
  //   Array.from(doc.images).forEach((image) => {
  //     if (!image.complete) {
  //       image.addEventListener("load", updateHeight, { once: true });
  //       image.addEventListener("error", updateHeight, { once: true });
  //     }
  //   });
  // };
  const getParsedAnalysis = (analysisInsights) => {
    if (!analysisInsights) return null;

    try {
      return JSON.parse(
        analysisInsights
          .replace(/^```json\s*/, "")
          .replace(/```$/, "")
          .trim()
      );
    } catch (e) {
      console.error("Invalid data", e);
      return null;
    }
  };

  const sanitizeFileNamePart = (value) =>
    String(value || "")
      .replace(/[<>:"/\\|?*\u0000-\u001F]/g, "-")
      .replace(/\s+/g, " ")
      .trim();

  const handleDownloadPdf = async () => {
    const report = getParsedAnalysis(analysisInsights);
    if (!report) {
      message.error("Generate a valid report before exporting to PDF.");
      return;
    }

    const selectedRange = rangePickerValue.length === 2
      ? rangePickerValue
      : form.getFieldValue("rangePicker");
    const datePeriod = Array.isArray(selectedRange) && selectedRange.length === 2
      ? `${dayjs(selectedRange[0]).format("YYYY-MM-DD")} to ${dayjs(selectedRange[1]).format("YYYY-MM-DD")}`
      : report?.meta?.date_range_display || "Date range unavailable";
    const buyerName = sanitizeFileNamePart(report?.meta?.buyer_name || "Buyer");
    const safeDatePeriod = sanitizeFileNamePart(datePeriod);
    const fileName = `Executive Summary - ${buyerName} - ${safeDatePeriod}.pdf`;

    setPdfLoading(true);
    try {
      const blob = await pdf(
        isMasterBuyer
          ? <AnalysisMasterSummaryPdf report={report} />
          : <AnalysisSummaryPdf report={report} />
      ).toBlob();
      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
      message.success("PDF downloaded successfully.");
    } catch (error) {
      console.error("Failed to generate executive summary PDF:", error);
      message.error("Failed to generate PDF.");
    } finally {
      setPdfLoading(false);
    }
  };

	return (
		<div>
      <Spin spinning={analysisloader} tip="Generating insights...">
      {/* <div className='uppercase font-bold text-xl'>Analysis</div>*/}
			<div className='overflow-x-auto'>
				<div  className="w-full">
					<Form form={form} onFinish={generateNewAnalysis}>
            <div className="flex items-end space-x-2 mb-1" >
            <Form.Item name="rangePicker" 
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
            >
							<RangePicker
                className="w-[306px]"
								placeholder={["From", "To"]}
								onChange={RangePickerChanged}
								format={constants.DateFormat2}
                disabledDate={disabledRangeDate}
                order={false}
                defaultPickerValue={dayjs().subtract(3, "month").startOf("month")}
              />
						</Form.Item>
            {/* <Form.Item>
            <Tooltip placement='right' title="Generate Report">
									<Button className=' mt-1' type='primary' 
									loading={loader}
                  onClick={()=>{
                    if(rangePickerValue.length!==0){      
										GetAnalysisReport(rangePickerValue[0].format(constants.DateFormat2),rangePickerValue[1].format(constants.DateFormat2),"f",currentPage,pageSize)
										}else{
                      message.error("Please select the date range to generate the report.")
                    }}}
									>Generate Report</Button>
								</Tooltip>
            </Form.Item> */}
            <Form.Item>
            <Tooltip placement='right' title="Download as Excel">
									<Button className='bg-green-800 text-white hover:!text-white hover:!border-green-500 mt-1' icon={<FileExcelOutlined />} 
									loading={loader}
                  // onClick={()=>{
                  //   if(rangePickerValue.length!==0){      
									// 	downloadFile(rangePickerValue[0].format(constants.DateFormat2),rangePickerValue[1].format(constants.DateFormat2))
									// 	}else{
                  //     message.error("Please select the date to download the file.")
                  //   }}}
                  onClick={()=>downloadFile()}
									/>
								</Tooltip>
            </Form.Item>
            </div>
            {checked===true?
            <div className="flex items-end space-x-2 mb-1">
            <Form.Item name="rangePickerChecked" 
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
            >
							<RangePicker
                className="w-[306px]"
								placeholder={["From", "To"]}
								onChange={RangePickerChangedCompare}
								format={constants.DateFormat2}
                disabledDate={disabledRangeDate}
                order={false}
                defaultPickerValue={dayjs().subtract(3, "month").startOf("month")}
							/>
						</Form.Item>
            {/* <Form.Item>
            <Tooltip placement='right' title="Generate Report">
									<Button className=' mt-1' type='primary' 
									loading={loader}
                  onClick={()=>{
                    if(rangePickerValue.length!==0){      
										GetAnalysisReport(rangePickerValueCompare[0].format(constants.DateFormat2),rangePickerValueCompare[1].format(constants.DateFormat2),"t",currentPageCompare,pageSizeCompare)
										}else{
                      message.error("Please select the date range to generate the report.")
                    }}}
									>Generate Report</Button>
								</Tooltip>
            </Form.Item> */}
            <Form.Item>
              <Tooltip placement='right' title="Download as Excel">
						  	<Button className='bg-green-800 text-white hover:!text-white hover:!border-green-500 mt-1' icon={<FileExcelOutlined />} 
						  	loading={loader}
                onClick={()=>{
                  if(rangePickerValueCompare.length!==0){      
						  		downloadFile(rangePickerValueCompare[0].format(constants.DateFormat2),rangePickerValueCompare[1].format(constants.DateFormat2))
						  		}else{
                    message.error("Please select the date to download the file.")
                  }}}
						  	/>
						  </Tooltip>
            </Form.Item>
            </div>
            :null}
            <Form.Item>
            <Checkbox 
            checked={checked}  onChange={(e)=>onCheckedChange(e)}
            >
              Compare
            </Checkbox>
            </Form.Item>
              <Form.Item>
                <div className="flex items-start gap-2">
                  <Button
                    icon={<FileExcelOutlined />}
                    className="bg-green-800 text-white hover:!text-white hover:!border-green-500"
                    htmlType="button"
                    onClick={generateSummary}
                    loading={loaderGenerateExcel}
                  >
                    Generate Summary
                  </Button>
                </div>
              </Form.Item>
            <Form.Item className="w-1/2" label="Claude Model" name="claudeModel">
                <Select 
                    allowClear 
                    showSearch
                    placeholder={<span className='text-sm normal-case'>Select Model</span>}  
                    className="w-1/2"
                    filterOption={(input, option) =>
                        (option?.props?.children ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                >
                {claudeModelList.map((item) => (
                <Option key={item} value={item}>{item}</Option>
                ))}
                </Select></Form.Item>
            <Form.Item name="prompt" label="Prompt" className="w-3/4"
             rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
            >
              <TextArea rows={10}  onChange={(e)=>setPromt(e.target.value)}/>
            </Form.Item>
            <Space className="mb-2">
              <Tooltip placement='right' title="Analysis">
                <Button
                  type='primary'
                  // className='bg-green-800 text-white hover:!text-white hover:!border-green-500 mb-2'
                  //onClick={()=>{GenerateInsifght()}}
                  htmlType='submit'
                >
                  Generate Report
                </Button>
              </Tooltip>
              <Button
                type="primary"
                htmlType="button"
                icon={<FilePdfOutlined />}
                onClick={handleDownloadPdf}
                loading={pdfLoading}
                disabled={!analysisInsights}
              >
                Export to PDF
              </Button>
              {/* <Button
                type="primary"
                onClick={handleExportPdf}
                loading={loading}
                icon={loading ? <LoadingOutlined /> : null}
              >
                Export to PDF
              </Button> */}
            </Space>
					</Form>
				</div>
      {/* {rangePickerValue.length!==0?
      <div className='overflow-x-auto '>
          <span className='font-semibold italic' >From {dayjs(rangePickerValue[0])?.format(constants.DateFormat2)} to {dayjs(rangePickerValue[1])?.format(constants.DateFormat2)}</span>
          <Table
            columns={columns}
            dataSource={reportData}
            scroll={{
              x: 1000,
              y: 420,
            }}
            onChange ={onchangeReportTable}
            pagination={{
								total: reportDataCount,
								showSizeChanger: true,
								pageSizeOptions: ["100","250", "500", "1000"],
								defaultPageSize: 100,
								 current: currentPage,
							}}
          />
      </div>
       :null}  */}
      {/* {rangePickerValueCompare.length!==0?
      <div className='overflow-x-auto mt-3'>
          <span className='font-semibold italic' >From {dayjs(rangePickerValueCompare[0])?.format(constants.DateFormat2)} to {dayjs(rangePickerValueCompare[1])?.format(constants.DateFormat2)}</span>
          <Table
            columns={columns}
            dataSource={reportDataCompare}
            scroll={{
              x: 1000,
              y: 420,
            }}
            onChange ={onchangeReportCompareTable}
            pagination={{
								total: reportDataCompareCount,
								showSizeChanger: true,
								pageSizeOptions: ["100","250", "500", "1000"],
								defaultPageSize: 100,
								 current: currentPageCompare,
							}}
          />
      </div>
      :null} */}
			{/* Card Below */}
      {analysisInsights ? (
        <Card className="mt-4 shadow-sm rounded-lg" ref={reportRef}>
          <div className="flex flex-col items-start space-y-3">
          <div className="whitespace-pre-wrap w-full">
            {analysisInsights ? (
              isMasterBuyer ? (
                <AnalysisMasterSummary report={getParsedAnalysis(analysisInsights)} />
              ) : (
                <AnalysisSummary report={getParsedAnalysis(analysisInsights)} />
              )
            ) : (
              "Your insights will appear here after you generate the insights."
            )}
          </div>
          <Button type="primary" onClick={()=>SaveAnalysis()}>
            Save
          </Button>
          </div>
        </Card>
      ) : null}

        {/* {analysisInsights ? (
          <Card
            className="mt-4 shadow-sm rounded-lg"
            ref={reportRef}
            styles={{ body: { padding: 0 } }}
          >
            <iframe
              ref={iframeRef}
              srcDoc={getHtmlContent(analysisInsights)}
              title="Analysis Report"
              className="w-full border-0"
              style={{
                width: "100%",
                height: "1px",
                display: "block",
                overflow: "hidden",
              }}
              onLoad={handleIframeLoad}
            />
            <div className="p-4">
              <Button
                type="primary"
                onClick={SaveAnalysis}
              >
                Save
              </Button>
            </div>
          </Card>
        ) : null} */}
			</div>
      </Spin>
		</div>
	);
};

export default AnalysisTest;
